<template>
  <div class="d-flex flex-column" style="min-height: 100vh">
    <!-- content -->
    <div style="flex: 1">
      <!-- logo -->
      <logo_display />
      <!-- logo -->

      <!-- heading -->
      <page_banner page_title="消費獎賞查詢" />
      <!-- heading -->

      <div class="text-center d-flex flex-column align-items-center mt-5">
        <!-- query form -->
        <b-form
          @submit.prevent="get_reward(fbo_id, fbo_name)"
          v-if="query_avaliable"
        >
          <b-form-input
            v-model="fbo_id"
            type="text"
            inputmode="numeric"
            maxlength="12"
            pattern="^[0-9]{12}$"
            required
            placeholder="輸入你的FBO ID"
            class="mb-3"
          >
            {{ fbo_id }}
          </b-form-input>
          <b-form-input
            v-model="fbo_name"
            type="text"
            required
            placeholder="輸入你的名字"
          >
            {{ fbo_name }}
          </b-form-input>
          <b-button class="mt-3" type="submit" variant="outline-success"
            >查詢</b-button
          >
        </b-form>
        <!-- query form -->

        <!-- is manager -->
        <b-alert variant="info" v-show="is_manager" class="mt-3 mx-3" show>
          閣下
          <div class="d-inline h4 text-danger fw-bold">未獲得產品兌換券</div>
          ，消費獎賞
          <div class="d-inline h4 text-danger fw-bold">只限非經理級FBO</div>
          。
        </b-alert>
        <!-- is manager -->

        <!-- query result -->
        <div v-if="has_coupon != null && error_message == ''" class="mt-3 mx-3">
          <!-- have coupon -->
          <b-alert
            v-if="has_coupon == true && quantity_of_coupon != 0"
            variant="success"
            show
          >
            <div>
              閣下有
              <div class="d-inline h4 text-danger fw-bold">未使用</div>
              的產品兌換券:
              <div class="d-inline h4 text-danger fw-bold">
                {{ quantity_of_coupon }}張
              </div>
              。
            </div>
          </b-alert>
          <!-- have coupon -->

          <!-- all coupon used -->
          <b-alert
            v-if="has_coupon == true && quantity_of_coupon == 0"
            variant="info"
            show
          >
            <div>閣下已使用本季度所有產品兌換券。</div>
          </b-alert>
          <!-- all coupon used -->

          <!-- have not coupon -->
          <b-alert v-if="has_coupon == false" variant="warning" show>
            <div>
              閣下
              <div class="d-inline h4 fw-bold">未獲得</div>
              產品兌換券。
            </div>
          </b-alert>
          <!-- have not coupon -->

          <!-- display redemption date -->
          <b-alert
            v-if="display_redemption_date != '' && quantity_of_coupon > 0"
            variant="success"
            show
            >請於
            <div class="d-inline h4 fw-bold">以下日期</div>
            內
            <div class="d-inline h4 fw-bold">換領產品</div>
            ：
            <div class="d-inline h4 fw-bold">
              {{ display_redemption_date }}
            </div>
          </b-alert>
        </div>
        <!-- display redemption date -->
        <!-- query result -->

        <!-- date warning -->
        <div v-if="!query_avaliable" class="mt-3">
          <b-alert variant="danger" show>
            目前尚未到達換領日期，請稍後再查詢。
          </b-alert>
          <b-table :items="redeem_date_range" :fields="redeem_date_fields">
          </b-table>
        </div>
        <!-- date warning -->

        <!-- error message display -->
        <div v-if="api_error" class="mt-3">
          <b-alert variant="danger" show>
            <b>{{ error_message }}</b>
          </b-alert>
        </div>
        <!-- error message display -->

        <!-- disclaimer -->
        <div class="mt-3 text-left">
          <ul>
            <li>箱積分及兌換券以每一季度結算，不可累積。</li>
            <li>兌換券須以指定日期內使用，逾期作廢。</li>
            <li>兌換券以電子方式記錄於公司之電腦系統內。</li>
            <li>如可兌換之產品有更改，怒不另行通知。</li>
          </ul>
        </div>
        <!-- disclaimer -->
      </div>
    </div>
    <!-- content -->
    <footer_page />
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import page_banner from "./page_banner.vue";
import logo_display from "./logo_display.vue";
import footer_page from "./footer_page.vue";
import api from "@/api/index.js";
import axios from "axios";

const fbo_id = ref("");
const fbo_name = ref("");
const is_manager = ref(null);
const has_coupon = ref(null);
const quantity_of_coupon = ref(null);
const query_avaliable = ref(false);

const redeem_date_fields = ref([
  {
    key: "quarter",
    label: "季度",
    class: "text-center",
  },
  {
    key: "redeem_date",
    label: "換領日期",
    class: "text-center",
    style: {},
  },
]);
let next_year = new Date().getFullYear() + 1;
const redeem_date_range = ref([
  { quarter: "第1季: 1-3月", redeem_date: "15/4 - 14/5" },
  { quarter: "第2季: 5-6月", redeem_date: "15/7 - 14/8" },
  { quarter: "第3季: 7-9月", redeem_date: "15/10 - 14/11" },
  {
    quarter: "第4季: 10-12月",
    redeem_date: `15/1/${next_year} - 14/2/${next_year}`,
  },
]);

const api_error = ref(false);
const error_message = ref("");

async function get_reward(fbo_id, fbo_name) {
  api_error.value = false;
  error_message.value = "";
  try {
    const response = await api.post("/api/check_fbo_voucher/", {
      fbo_id: fbo_id,
      fbo_name: fbo_name,
    });
    has_coupon.value = response.data.has_coupon;
    quantity_of_coupon.value = response.data.quantity_of_coupon;
    is_manager.value = response.data.is_manager;

    console.log(is_manager.value);
    console.log(has_coupon.value);
    console.log(quantity_of_coupon.value);
  } catch (error) {
    api_error.value = true;
    if (axios.isAxiosError(error)) {
      if (error.response) {
        console.log(`http status code: ${error.response.status}`);
        console.log(error.response.data.error);
        error_message.value =
          error.response.data.error_message || "伺服器無回應錯誤訊息。";
      } else if (error.request) {
        console.log("網路錯誤或伺服器無回應:", error.request);
        error_message.value = "網路連接失敗，請檢查您的網路或稍後再試。";
      }
    } else {
      console.log("not axios error");
      console.log(error);
      error_message.value = "發生未知錯誤。";
    }
  }
}

const display_redemption_date = ref("");
onMounted(() => {
  let current = new Date();
  let current_month = current.getMonth();
  if (current_month == 3 || current_month == 4) {
    display_redemption_date.value = `15/4/${current.getFullYear()} - 14/5/${current.getFullYear()}`;
  }
  if (current_month == 6 || current_month == 7) {
    display_redemption_date.value = `15/7/${current.getFullYear()} - 14/8/${current.getFullYear()}`;
  }
  if (current_month == 9 || current_month == 10) {
    display_redemption_date.value = `15/10/${current.getFullYear()} - 14/11/${current.getFullYear()}`;
  }
  if (current_month == 0 || current_month == 1) {
    display_redemption_date.value = `15/1/${current.getFullYear()} - 14/2/${current.getFullYear()}`;
  }
});
onMounted(() => {
  let redeem_year = new Date().getFullYear();
  let current_date = new Date();

  let reddem_date_range = [
    [15, 0, 14, 1],
    [15, 3, 14, 4],
    [15, 6, 14, 7],
    [15, 9, 14, 10],
  ];
  for (const [
    start_day,
    start_month,
    end_day,
    end_month,
  ] of reddem_date_range) {
    let start_date = new Date(redeem_year, start_month, start_day, 10);
    let end_date = new Date(redeem_year, end_month, end_day, 23, 59, 59);
    if (start_date <= current_date && current_date <= end_date) {
      query_avaliable.value = true;
    }
  }
});
</script>
